'use client';

import dynamic from 'next/dynamic';

const Devtools = dynamic(
  () => import('@tanstack/react-query-devtools').then((m) => m.ReactQueryDevtools),
  { ssr: false },
);

export function ReactQueryDevtoolsLazy() {
  return <Devtools initialIsOpen={false} />;
}
